import { FC } from 'react';

import { FormSubmit } from 'libs/form';
import { Stack } from 'libs/ui';
import { DeepPartial } from 'types/deepPartial';

import {
  SkeletonOrder,
  OrderForm,
  OrderFormContent,
  OrderFormHeader,
  OrderFormHeaderProps,
  OrderHeader,
} from '../../components';
import { OrderFormFooter } from '../../components/OrderFormFooter';
import { OrderFormType } from '../../forms/orderForm';

import { ContentStyled } from './styles';

export interface OrderViewProps extends OrderFormHeaderProps {
  loading?: boolean;
  submitLoading?: boolean;
  initialValues?: DeepPartial<OrderFormType>;
  onSubmit: FormSubmit<OrderFormType>;
}

export const OrderView: FC<OrderViewProps> = ({
  loading,
  initialValues,
  submitLoading,
  onSubmit,
  ...headerProps
}) => (
  <ContentStyled>
    <Stack flex={1} spacing={32}>
      {loading ? (
        <>
          <OrderHeader title={headerProps.title} />
          <SkeletonOrder />
        </>
      ) : (
        <OrderForm initialValues={initialValues} onSubmit={onSubmit}>
          <OrderFormHeader {...headerProps} />
          <OrderFormContent />
          <OrderFormFooter submitLoading={submitLoading} />
        </OrderForm>
      )}
    </Stack>
  </ContentStyled>
);
